import script from "./20CH.vue?vue&type=script&setup=true&lang=js"
export * from "./20CH.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__